import { ofType } from "redux-observable";
import { map, switchMap } from "rxjs/operators";
import { getJSON } from "../utils/ajaxUtil";
import {
  receiveActivities,
  receiveActivityById,
  REQUESTED_ACTIVITIES,
  REQUESTED_ACTIVITY_BY_ID,
} from "../redux/actions/activityAction";

export const fetchActivities = (action$) =>
  action$.pipe(
    ofType(REQUESTED_ACTIVITIES),
    map((action) => action.payload.activity),
    switchMap((activity) =>
      getJSON(`/activities`).pipe(map((res) => receiveActivities(res.data)))
    )
  );

export const fetchActivityById = (action$) =>
  action$.pipe(
    ofType(REQUESTED_ACTIVITY_BY_ID),
    map((action) => action.payload.id),
    switchMap((id) =>
      getJSON(`/activities/${id}`).pipe(
        map((res) => receiveActivityById(res.data))
      )
    )
  );
